// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-input-integration-layout-nEZ4cK{z-index:var(--chat-z-index-input,50);flex-direction:column;justify-content:center;align-items:center;display:flex;position:relative}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chat-input-integration-layout": `chat-input-integration-layout-nEZ4cK`,
	"chatInputIntegrationLayout": `chat-input-integration-layout-nEZ4cK`
};
export default ___CSS_LOADER_EXPORT___;
